<template>
    <div class="div-bookmark">
        <el-tabs class="base-tabs" type="border-card">
            <el-tab-pane label="书签列表">
                <list-com />
            </el-tab-pane>
            <el-tab-pane label="书签动画">
                <animation-com />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import list from "./list.vue"
import animation from "./animation.vue"
export default {
    components:{
        "list-com":list,
        "animation-com":animation
    },
    data() {
        return {

        };
    },

    mounted() {

    },

    methods: {

    },
};
</script>

<style lang="scss" scoped></style>